import * as React from 'react'
import I18n from '../../../../core/i18n'
import { reservationService } from '../../../../core/services'
import { CheckBox, InputText, Select } from '../../../atoms'
import { Form } from 'components/molecules'
import * as interfaces from '../../../../static/interfaces'
import WithLabel from 'components/atoms/WithLabel'
import Typography from 'components/atoms/_layouts/Typography'
declare var window: interfaces.IWindow

type IOnFinish = (id?: any, reservation?: any, flush?: any) => void
interface IProps {
  id: string | number
  currentUser: any
  cancelReasons: any[]
  formRef: React.MutableRefObject<any>
  onFinish: IOnFinish
}
const declineReservation = async (id, values, onFinish) => {
  try {
    const { reservation, flush } = await reservationService.declineReservation(id, values)

    onFinish(id, reservation, flush)
    window.globalModal.closeModal()
  } catch (error) {
    console.error(error)
  }
}
const FIELDS = {
  host_cancel_reason: 'host_cancel_reason',
  cancellation_requested_by_guest: 'cancellation_requested_by_guest',
  canceled_by: 'canceled_by',
}

const DeclineModalBody: React.FC<IProps> = props => {
  const [cancelErrors, setCancelErrors] = React.useState<{ reason: null | string }>({
    reason: null,
  })

  const options = props.cancelReasons.map(({ id, reason, reason_ja }) => ({
    id,
    value: id,
    label: I18n.locale === 'ja' ? reason_ja : reason,
  }))
  return (
    <div style={{ width: '600px' }}>
      <Form
        ref={props.formRef}
        fields={FIELDS}
        handleUpdateForm={(updatedErrors, isSubmitEnabled) => setCancelErrors(updatedErrors)}
        handleSubmit={(initialValues, values) =>
          declineReservation(props.id, values, props.onFinish)
        }
      >
        <WithLabel label={'理由を選択してください'}>
          <Select options={options} defaultValue={'1'} name="host_cancel_reason" />
        </WithLabel>

        <WithLabel label={'ゲストからのキャンセル要望ですか？'}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CheckBox name="cancellation_requested_by_guest" defaultChecked={false} />
            <label htmlFor="cancellation_requested_by_guest">
              <Typography type="body" color="subtext">
                ゲストからの要望の場合チェックをつけて下さい
              </Typography>
            </label>
          </div>
        </WithLabel>
        <WithLabel label={'キャンセルを行うユーザー'}>
          <InputText defaultValue={props.currentUser.username} name="canceled_by" />
        </WithLabel>
      </Form>
    </div>
  )
}

export const showDeclineModal = async (
  currentUser: any,
  id: string,
  onFinish: IOnFinish,
  formRef: React.MutableRefObject<any>,
  cancelReasons: any[]
) => {
  window.globalModal.showModal({
    title: I18n.t('cancel.cancel_reservation'),
    body: (
      <DeclineModalBody
        currentUser={currentUser}
        id={id}
        onFinish={onFinish}
        cancelReasons={cancelReasons}
        formRef={formRef}
      />
    ),
    closeText: I18n.t('generic.close'),
    submitText: I18n.t('cancel.cancel_reservation'),
    handleSubmit: () => {
      if (window.confirm(I18n.t('generic.decline_confirmation'))) {
        formRef.current.handleFormSubmit()
      }
    },
  })
}
